<template>
  <main class="dashboard">
    <!-- Основная карточка с информацией о ссылке -->
    <div class="card info-card">
      <div class="card-header">
        <div class="header-content">
          <h3 class="target-link">
            <i class="bi bi-link-45deg"></i>
            Целевая ссылка:
            <a :href="link.link" target="_blank" class="link-primary">{{ link.link }}</a>
          </h3>
          <div class="actions-section">
            <button class="btn btn-warning btn-sm">
              <i class="bi bi-arrow-clockwise"></i> Получить новые данные
            </button>
            <p class="update-info">
              <i class="bi bi-clock-history"></i>
              <small>Данные получены: {{ link.date_create }}</small>
            </p>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-lg-8">
            <div class="meta-grid">
              <div class="meta-item">
                <span class="meta-label"><i class="bi bi-file-text"></i> Текст:</span>
                <a :href="link.text_file" target="_blank"
                   class="meta-link">{{ link.text_file ? 'Ссылка на OD файл' : '—' }}</a>
              </div>
              <div class="meta-item">
                <span class="meta-label"><i class="bi bi-clipboard-check"></i> ТЗ:</span>
                <a :href="link.ta_file" target="_blank"
                   class="meta-link">{{ link.ta_file ? 'Ссылка на ТЗ файл' : '—' }}</a>
              </div>
              <div class="meta-item">
                <span class="meta-label"><i class="bi bi-code-slash"></i> HTML:</span>
                <a :href="link.html_link" target="_blank"
                   class="meta-link">{{ link.ta_file ? 'Ссылка на сохранённую статью' : '—' }}</a>
              </div>
              <div class="meta-item">
                <span class="meta-label"><i class="bi bi-trello"></i> PlanFix:</span>
                <a :href="`https://serm-dr.planfix.ru/task/${link.pf_id}/`" target="_blank" class="meta-link">
                  {{ link.pf_id ? `Задача #${link.pf_id}` : '—' }}
                </a>
              </div>
            </div>

            <div class="indexing-section mt-4">
              <h5 class="section-title"><i class="bi bi-search"></i> Индексация</h5>
              <div class="indexing-badges">
                <span class="index-badge" :class="link.yandex_index ? 'index-yes' : 'index-no'">
                  <i class="bi" :class="link.yandex_index ? 'bi-check-circle-fill' : 'bi-x-circle-fill'"></i>
                  Yandex
                </span>
                <span class="index-badge" :class="link.google_index ? 'index-yes' : 'index-no'">
                  <i class="bi" :class="link.google_index ? 'bi-check-circle-fill' : 'bi-x-circle-fill'"></i>
                  Google
                </span>
              </div>

              <div class="table-responsive mt-3">
                <table class="table table-sm table-hover searches-table">
                  <thead>
                  <tr>
                    <th>Запрос</th>
                    <th>Позиция</th>
                    <th>Поисковик</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="search in link.searches" :key="search.id">
                    <td>{{ search.result__keyword__name }}</td>
                    <td><span class="badge bg-primary">{{ search.place }}</span></td>
                    <td><i :class="search.result__engine__code"></i></td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <TargetTables v-if="link" :link="link"></TargetTables>


          </div>

          <div class="col-lg-4">
            <!-- Место для SimLinks -->
          </div>
        </div>
      </div>
    </div>
    <CompareStats v-if="link.text" :doc="link.text" :placed="link.html_text"></CompareStats>
  </main>
</template>

<script>
import {HTTP} from "@/api/common";
import SimLinks from "@/components/SimLinks.vue";
import TargetTables from "@/views/planfix/components/TargetTables.vue";
import CompareStats from "@/views/planfix/components/CompareStats.vue";

export default {
  name: 'TargetLink',
  components: {CompareStats, TargetTables, SimLinks},
  data() {
    return {
      link: {}
    }
  },
  mounted() {
    const $this = this;
    HTTP.get(`planfix/target/${this.$route.params.link_id}/`).then((response) => {
      $this.link = response.data;
    });


  },
  computed: {

  },
  methods: {

    editDistance(s1, s2) {
      s1 = s1.toLowerCase();
      s2 = s2.toLowerCase();

      const costs = [];
      for (let i = 0; i <= s1.length; i++) {
        let lastValue = i;
        for (let j = 0; j <= s2.length; j++) {
          if (i === 0) {
            costs[j] = j;
          } else if (j > 0) {
            let newValue = costs[j - 1];
            if (s1.charAt(i - 1) !== s2.charAt(j - 1)) {
              newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
            }
            costs[j - 1] = lastValue;
            lastValue = newValue;
          }
        }
        if (i > 0) costs[s2.length] = lastValue;
      }
      return costs[s2.length];
    },
    similarity(s1, s2) {
      if (!s1 || !s2) return 0;

      let longer = s1;
      let shorter = s2;
      if (s1.length < s2.length) {
        longer = s2;
        shorter = s1;
      }
      const longerLength = longer.length;
      if (longerLength === 0) return 1.0;

      return (longerLength - this.editDistance(longer, shorter)) / parseFloat(longerLength);
    },
    findSim(text, search, percent = 0.8) {
      let comp = null;
      search.every((e) => {
        const sim = this.similarity(e, text);
        if (sim > percent) comp = e;
        return sim < percent;
      });
      return comp;
    },
    findDiff(compared, structure) {
      let diff = "";
      const $this = this;
      const text = compared.text?.replace("&nbsp;", " ") || "";
      const compare = this.findSim(compared.text, structure.map(x => x.text));

      if (compare) {
        const compareWords = compare.split(/\s|&nbsp;/g);
        text.split(/\s|&nbsp;/g).forEach(function (val) {
          const sim = $this.findSim(val, compareWords, 0.99);
          if (val.toLowerCase() !== (sim || '').toLowerCase()) {
            diff += `<span class="bg-red">${val} </span>`;
          } else {
            diff += val + ' ';
          }
        });
      } else {
        diff = `<span class="bg-red">${text}</span>`;
      }
      return diff;
    },
  }
}
</script>

<style scoped>

.header-content {
  display: flex;
  gap: 50px;

  .target-link {
    font-size: 1.25rem;
    font-weight: 600;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }

  .actions-section {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
  }

  .update-info {
    margin: 0;
    display: flex;
    align-items: center;
    gap: 6px;
  }

}


.meta-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 12px;

  .meta-item {
    display: flex;
    align-items: center;
    gap: 8px;
    background: rgba(60, 60, 60, 1);
    padding: 10px 14px;
    border-radius: 10px;
    backdrop-filter: blur(10px);


    .meta-label {
      font-weight: 600;
      color: rgba(255, 255, 255, 0.85);
      font-size: 0.85rem;
      display: flex;
      align-items: center;
      gap: 6px;
    }

    .meta-link {
      color: #fff;
      text-decoration: none;
      font-size: 0.85rem;
      border-bottom: 1px dashed rgba(255, 255, 255, 0.5);
      transition: all 0.2s ease;

      &:hover {
        border-bottom-style: solid;
        border-bottom-color: #fff;
      }
    }

  }
}


.indexing-section {



  .section-title {
  background: rgba(60, 60, 60, 1);
  padding: 10px;
  border-radius: 12px;
  color: #fff;
        font-size: 1.05rem;
        display: flex;
    gap: 5px;
}

  .indexing-badges {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;

    .index-badge {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      padding: 6px 14px;
      border-radius: 20px;
      font-size: 0.85rem;
      font-weight: 500;

      &.index-yes {
        background: rgba(40, 167, 69, 0.9);
        color: #98f5b0;
      }

      &.index-no {
        background: rgba(220, 53, 69, 0.9);
        color: #ffb3b8;
      }

    }

  }
}


.searches-table {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 0;

  thead th {
    background: #f1f3f5;
    border: none;
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #6c757d;
    font-weight: 600;
    padding: 10px 14px;
  }

  tbody td {
    padding: 10px 14px;
    vertical-align: middle;
    border-color: #f1f3f5;
  }

  tbody tr:hover {
    background: #f8f9fa;
  }

}


</style>